import React from 'react';

function Console(props) {
  return (
    <svg viewBox="0 0 25 20" stroke="black" {...props}>
      <title>logs</title>
      <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <path d="M24 17a2 2 0 01-2 2H3a2 2 0 01-2-2V3a2 2 0 012-2h19a2 2 0 012 2v14zM2 6h22" />
        <path d="M5 3.5a.5.5 0 11-1 0 .5.5 0 011 0zm3 0a.5.5 0 11-1 0 .5.5 0 011 0zm3 0a.5.5 0 11-1 0 .5.5 0 011 0zM1 13h5l2-3 2 5 4-6 3 7 2-3h5" />
      </g>
    </svg>
  );
}

export default Console;
